import React, { memo } from "react";
import "./project-key-color-picker.css";
import { colors as PALETTE } from "../icons/icons";

const ProjectKeyColorPicker = memo(({ value, onChange, codeText = "PRJ", disabled, className = "", style }) => {
  const normalized = (v) => (typeof v === "string" ? v.toUpperCase() : v);

  return (
    <div className={`pkc-wrap ${className}`} style={style} role="listbox" aria-label="Key color">
      {PALETTE.map(({ backgroundColor, color }) => {
        const base = normalized(backgroundColor);
        const isActive = normalized(value) === base;

        return (
          <div
            key={base}
            className={`pkc-swatch ${isActive ? "pkc-swatch--active" : ""} ${disabled ? "pkc-swatch--disabled" : ""}`}
            style={{
              backgroundColor: base,
              color,
              boxShadow: isActive ? `0 0 0 2px #fff, 0 0 0 3px ${color}` : `0 0 0 2px #fff`,
              cursor: disabled ? "default" : "pointer",
            }}
            role="option"
            aria-selected={isActive}
            title={base}
            onClick={() => {
              if (disabled) return;
              onChange?.(base);
            }}
          >
            <span className="pkc-code">{codeText}</span>
          </div>
        );
      })}
    </div>
  );
});

export default ProjectKeyColorPicker;